module.exports = __webpack_public_path__ + "fonts/manrope-thin.8d7acaf9.woff2";